import { Injectable } from '@angular/core';
import { IResponse } from '@interfaces/index';
import { HttpService } from '@ui-components/services';
import { IAssessmentExtended, IQuestionResponse } from 'projects/ui-components/src/interfaces/IAssessment';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class AssessmentService {

  constructor(
    private http_service: HttpService
  ) { }

  private buildAssessmentPayload(assessment: IAssessmentExtended, extraParams: any = {}): any {
    return {
      org_person_assessment_id: assessment.org_person_assessment_id,
      assessment_id: assessment.assessment_id,
      person_id: assessment.person_id,
      ...extraParams
    };
  }

  approve(assessment: IAssessmentExtended): Observable<IResponse<{}>> {
    return this.http_service.post('assessments/approve', this.buildAssessmentPayload(assessment));
  }

  assign(params: {
    cohort_id: number | null,
    org_id: number,
    assessment_id: number,
    selected_users: number[],
    close_dt: string
  }): Observable<IResponse<{}>> {
    return this.http_service.post('assessments/assign', params)
  }

  cancel(assessment: IAssessmentExtended): Observable<IResponse<{}>> {
    return this.http_service.post('assessments/cancel', this.buildAssessmentPayload(assessment));
  }

  complete(token: string) {
    return this.http_service.post('assessments/complete', {
      token
    });
  }

  createLink(params: { assessment_id: number; org_id: number; close_dt?: string }): Observable<
    IResponse<{ link: string; expiration_date?: string; remaining_inventory?: number }>
  > {
    return this.http_service.post('assessments/create-link', params);
  }

  getMyAssessments(): Observable<IResponse<IAssessmentExtended[]>> {
    return this.http_service.post('assessments/my-assessments', {})
  }

  getQuestions(token: string): Observable<IResponse<IQuestionResponse>> {
    return this.http_service.post('assessments/get-questions', {
      token
    })
  }

  getTeamAssessments(org_id: number, search: string | null = null): Observable<IResponse<IAssessmentExtended[]>> {
    return this.http_service.post('assessments/get-team-assessments', {
      org_id: org_id,
      search
    })
  }

  invite(params: {
    selected_assessment_id: number,
    selected_org_id: number,
    selected_cohort_id?: number,
    registered_users?: number[],
    registered_emails?: string[],
    unregistered_users?: string[],
    close_dt?: Date;
  }): Observable<IResponse<{}>> {
    return this.http_service.post('assessments/invite', params)
  }

  reminder(assessments: IAssessmentExtended[]): Observable<IResponse<{}>> {
    const usersArray = assessments.map(assessment => this.buildAssessmentPayload(assessment));
    return this.http_service.post('assessments/send-reminder', { users: usersArray });
  }

  renew(assessment: IAssessmentExtended): Observable<IResponse<{}>> {
    const newDueDate = new Date();
    newDueDate.setDate(newDueDate.getDate() + 30);

    return this.http_service.post('assessments/renew', this.buildAssessmentPayload(assessment, { new_due_date: newDueDate }));
  }

  saveAnswer<T>(params: T) {
    return this.http_service.post('assessments/save-answer', params);
  }

}